// extracted by mini-css-extract-plugin
module.exports = {"ul":"Paginado_ul__-0k3q","li":"Paginado_li__3yeSq","button":"Paginado_button__f1aJK","pagination":"Paginado_pagination__1emtv"};